export default __webpack_public_path__ + "static/gg-eab57fc127ae34d27b957949aa40da72.gif";